




import { Vue, Component, Prop } from "vue-property-decorator";

/**
 * This component is like a simple *\<hr\>* html tag with some features and predefined layout.
 */
@Component({})
export default class AnxHrLine extends Vue {
  /**
   * The color of the hr line (the colors are predefined)
   * @values grey, green, blue
   */
  @Prop({ default: "grey" }) color!: string;

  /** The margin top and bottom */
  @Prop({ default: "40px" }) margin!: string;

  /** The margin top (if set, margin property will be overwritten) */
  @Prop({ default: null }) marginTop!: string | null;

  /** The margin bottom (if set, margin property will be overwritten) */
  @Prop({ default: null }) marginBottom!: string | null;

  get cssProps() {
    return {
      "--marginTop": this.marginTop !== null ? this.marginTop : this.margin,
      "--marginBottom":
        this.marginBottom !== null ? this.marginBottom : this.margin
    };
  }
}
